export function isSyntheticUserEmail(email) {
  const value = String(email || '').trim().toLowerCase();
  if (!value) return true;
  if (/\.vurgunbet\.local$/i.test(value)) return true;
  if (/@(?:oauth\.)?vurgunbet\.local$/i.test(value)) return true;
  return false;
}

export function displayUserEmail(email) {
  if (isSyntheticUserEmail(email)) return '-';
  const value = String(email || '').trim();
  return value || '-';
}

export function hasUserEmail(email) {
  return !isSyntheticUserEmail(email);
}

export function hasUserPhone(phone) {
  const value = String(phone || '').trim();
  return Boolean(value) && value !== '-' && value !== '—';
}
